import { render, staticRenderFns } from "./vRecipeBreakdownTable.vue?vue&type=template&id=d35b3738&scoped=true"
import script from "./vRecipeBreakdownTable.vue?vue&type=script&lang=ts"
export * from "./vRecipeBreakdownTable.vue?vue&type=script&lang=ts"
import style0 from "./vRecipeBreakdownTable.vue?vue&type=style&index=0&id=d35b3738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d35b3738",
  null
  
)

export default component.exports